import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal } from './Reveal';

export const CTASection = ({ title = 'Ready to prove your organization can recover?', text = 'Schedule a consultation with a practitioner. We will assess where you stand and show you exactly what readiness looks like for your organization.' }) => (
    <section className="relative overflow-hidden py-20 sm:py-28" data-testid="cta-section">
        <div className="pointer-events-none absolute inset-0 grid-lines opacity-60" />
        <div className="pointer-events-none absolute -top-32 left-1/2 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-deepteal/10 blur-[120px]" />
        <div className="relative mx-auto max-w-4xl px-4 sm:px-6 text-center">
            <Reveal>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-50 text-balance">
                    {title}
                </h2>
                <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-400">{text}</p>
                <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <Link
                        to="/contact"
                        data-testid="cta-schedule-button"
                        className="inline-flex items-center gap-2 rounded-full bg-glow px-8 py-4 text-sm font-semibold text-ink transition-transform duration-200 hover:scale-105 hover:shadow-xl hover:shadow-glow/25"
                    >
                        Schedule a Consultation <ArrowUpRight size={16} />
                    </Link>
                    <Link
                        to="/services"
                        data-testid="cta-services-button"
                        className="inline-flex items-center gap-2 rounded-full border border-slate-500 px-8 py-4 text-sm font-semibold text-slate-200 transition-colors duration-200 hover:border-deepteal/40 hover:text-deepteal"
                    >
                        Explore Services
                    </Link>
                </div>
            </Reveal>
        </div>
    </section>
);
